import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import {
  FlagsControllerApi,
} from "../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  useBaseContent,
} from "../../../utils/utils";

interface Props {
  enabled?: boolean;
  pagination: DGT_Pagination;
  archive?: boolean;
  gridSorting: GridSortItem[]; 
  xTENANTID?: string; 
  name?: string;
  active?: boolean;
}

export type OptionData = {
  name: string;
  uuid: string;
  color: string;
};

/**
 *
 * @author [Atish Bagate]
 */
  export const useGetFlagList = ({
  enabled,
  pagination,
  archive,
  gridSorting,
  xTENANTID,
  name,
  active
}: Props): useBaseContent<OptionData> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: "",
    prevPage,
  });

  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "firstName" : undefined;

  return useQuery({
    queryKey: [
      "flag-list",
      pageIndex,
      pagination.pageSize,
      sortDirect, 
      name,
      active,
      archive, 
      sortBy, 
      xTENANTID,
    ],

    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: enabled,
    queryFn: async () =>
      await new FlagsControllerApi(getConfigObject())
        .getAllFlags(
          pageIndex, //page
          pagination.pageSize, //size
          sortBy, // sortBy 
          undefined, // sort
          name,
          active, // active
          archive, // archive
          xTENANTID
        )
        .then((res) => res?.data),
  });
}; 